import script from "./EditTopicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTopicForm.vue?vue&type=script&setup=true&lang=js"

import "./EditTopicForm.vue?vue&type=style&index=0&id=05a499ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a499ce"]])

export default __exports__